import { Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useProgramEngagementContext } from '../../../../context'
import { RequiredDocumentsAPI } from '../../../ResourceDetailFeatures/EQIP/RequiredDocumentsAPI'

export const PrefillEqipContractButton = () => {
  const { t } = useTranslation('@cibo/programs/PrefillEqipContractButton')
  const { engagementId } = useProgramEngagementContext()

  return (
    <Box>
      <Button
        variant="contained"
        onClick={() => {
          engagementId &&
            RequiredDocumentsAPI.inferContractData({ engagementId, simulateOnly: false })
        }}
      >
        {t('prefillValues')}
      </Button>
    </Box>
  )
}
